<template>
  <!-- .company-info-basic .cib -->
  <div> 
    <div class="cib" v-if="openBool" style="position:relative;">
      <Button @click="$emit('finish')" style="position:absolute;top:30px;right:30px;">Back</Button>
      <Row style="margin-right:60px;">
        <Col span="12">
          <div class="cib-l">
            <div class="cib-form">
              <Form
                ref="formInline2"
                :model="formInline2"
                :rules="ruleInline2"
                label-position="right"
                :label-width="230"
                @submit.native.prevent
              >
                <FormItem label="Company name：" prop="name">
                  <Input type="text" v-model="formInline2.name" disabled placeholder="Company name" />
                    <br />
                    <span style="font-size:12px; color:#a7a7a7;">(The company name has to be exactly same with the business license)</span>
                  </FormItem>
                </FormItem>
                <FormItem label="Company name abbreviation：" prop="shortName">
                  <Input type="text" v-model="formInline2.shortName" placeholder="Company name abbreviation" />
                </FormItem>
                <!-- 企业类型 -->
                <FormItem label="Type of enterprise：" prop="type">
                  <Select
                    v-model="formInline2.type"
                    placeholder="Please select type of enterprise"
                  >
                    <Option
                      v-for="(item, index) in exTypeList"
                      :key="item.nameEn"
                      :value="item.nameEn"
                    >{{ item.nameEn }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="Staff size：" prop="staff">
                  <Select
                    v-model="formInline2.staff"
                    placeholder="Please select staff size"
                  >
                    <Option
                      v-for="(item, index) in staffArr"
                      :key="item.value"
                      :value="item.value"
                    >{{ item.value }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="Annual sales：" prop="sales">
                  <Input
                    type="text"
                    v-model="formInline2.sales"
                    placeholder="Please enter annual sales"
                  />
                </FormItem>
                <FormItem label="Company website：" prop="Website">
                  <Input type="text" v-model="formInline2.Website" placeholder="Company website" />
                </FormItem>

                <FormItem label="Country and region：" prop="country">  
                  <Select 
                    v-model="formInline2.country"
                    placeholder="Country and region" 
                    filterable
                  >
                    <Option
                      v-for="(item, index) in countryList"
                      :key="item.nameEn"
                      :value="item.nameEn" 
                    >{{ item.nameEn }}</Option>
                  </Select>  
                </FormItem>
                <FormItem label="Province/State：" style="margin-bottom: 0;" :required="true" v-if="formInline2.country === 'China'">
                  <Row type="flex" justify="space-between">
                    <Col span="11">
                      <FormItem prop="province">
                        <Select
                          v-model="formInline2.province"
                          placeholder="Province"
                          @on-change="changeProvince"
                        >
                          <Option
                            v-for="(item, index) in provinceArr"
                            :key="index"
                            :value="item.pinyin"
                            @click.native="changeProvinceValue(item)"
                          >{{ item.pinyin }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="11" v-if="citiesArr && citiesArr.length">
                      <FormItem prop="city" class="com-city">
                        <Select v-model="formInline2.city" placeholder="State" @on-change="changeCity">
                          <Option
                            v-for="(item, index) in citiesArr"
                            :key="index"
                            :value="item.pinyin"
                          >{{ item.pinyin }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>


                <FormItem label="Address：" prop="address">
                  <Input type="text" v-model="formInline2.address" placeholder="Address" />
                </FormItem>
                <FormItem label="Social Unified Credit Code：">
                  <Input type="text" v-model="formInline2.CreditCode" placeholder="Social Unified Credit Code" />
                </FormItem>

                <FormItem label="Type of corporate assets：" prop="BusinessType">
                  <Select v-model="formInline2.BusinessType" style="width:100%">
                    <Option
                      v-for="item in BusinessList"
                      :value="item.nameEn"
                      :key="item.nameEn"
                    >{{ item.nameEn }}</Option>
                  </Select>
                </FormItem>

                <FormItem label="Type of business：" prop="Nature">
                  <Select v-model="formInline2.Nature" style="width:100%">
                    <Option
                      v-for="item in NatureList"
                      :value="item.nameEn"
                      :key="item.nameEn"
                    >{{ item.nameEn }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="Company details：">
                  <div class="no-padding">
                    <customComponentCommon
                      v-model="Introduction"
                      :type="commonType"
                      @change="changModal"
                    ></customComponentCommon>
                  </div>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    @click="handleSubmit('formInline2')"
                    style="width: 154px;"
                  >Save</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </Col>
        <Col span="12">
          <div class="cib-r" style="padding-top: 57px;">
            <Form label-position="right" :label-width="160" @submit.native.prevent> 
              <FormItem label="Logo：" prop="name">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div
                      class="my-upload-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                      style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
                    >
                      <template v-if="item.status === 'finished'">
                        <img :src="item.url" style="width: 150px;height: 150px;" v-if="item.url" />
                        <img :src="Logo" style="width: 150px;height: 150px;" v-else />
                        <div class="my-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                          <!-- <Icon
                        type="ios-trash-outline"
                        @click.native.stop.prevent="handleRemoveByArr(item)"
                          ></Icon>-->
                        </div>
                      </template>
                      <template v-else>
                        <Spin v-if="item.showProgress" style="width: 150px;height: 150px;">
                          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div
                    class="my-upload-list"
                    style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
                    v-else
                  >
                    <img :src="Logo" style="width: 150px;height: 150px;" />
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>Picture size：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>Picture size：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>Picture size：200*200px</p>
                    </div>
                  </div>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  style="display: inline-block;position: relative;"
                >
                  <Button icon="ios-cloud-upload-outline">Change the logo</Button>
                  <!-- <div style="width: 80px;height:80px;padding-top: 7px;">
                    <div>
                      +
                      <p>上传图片</p>
                    </div>
                  </div>-->
                  <!-- 蒙版 -->
                  <div
                    style="position:absolute;opacity:0;width:157px;height:34px;left:0;top:0;cursor:pointer;"
                    @click.stop="selectType"
                  ></div>
                </Upload>
                <p class="upload-p">(Requirements: .jpg/.png, suggested size is 120*120px)</p>
              </FormItem>

              <FormItem label="Business license：" :required="true">
                <div class="my-upload">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList2"
                    :key="'upload2-' + index"
                    style="width: 150px;height:100px;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width: 150px;height:100px;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 150px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload2"
                    :show-upload-list="false"
                    :default-file-list="defaultList2"
                    :on-success="handleSuccess2"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize2"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    :before-upload="handleBeforeUpload2"
                    style="display: inline-block;width: 150px;"
                    v-show="uploadList2 && uploadList2.length <1"
                  >
                    <div style="width: 150px;height:100px;padding-top: 17px;">
                      <div style="font-size:20px">
                        +
                        <p style="font-size:14px">Upload</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:150px;height:100px;left:0;top:0;"
                      @click.stop="selectType2"
                    ></div>
                  </Upload>
                </div>
                <div class="my-upload-tip">（Requirements: .jpg/png within 4M）</div>
              </FormItem>
            </Form>
          </div>
        </Col>
      </Row>

      <!-- 选择文件上传方式 -->
      <imgUpload
        @upload:local="uploadLocal"
        @upload:material="uploadMaterial"
        :maxCount="1"
        v-model="uploadChooseShowed"
      />
      <!-- 选择文件上传方式 -->
      <imgUpload
        @upload:local="uploadLocal2"
        @upload:material="uploadMaterial2"
        :maxCount="1"
        v-model="uploadChooseShowed2"
      />
      <!-- 图片查看 -->
      <iModal title="图片查看" cancel-text v-model="visible">
        <div style="text-align: center;">
          <img :src="imgName" v-if="visible" style="max-width: 100%" />
        </div>
      </iModal>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { provinces } from "@/other/provinces";
import { mapGetters, mapActions } from "vuex";
import customComponentCommon from "@components/En/custom-component/custom-component-common.vue";
import imgUpload from "@components/En/imgUpload/imgUpload.vue";
import defaultLogo from "@assets/img/empty.png";

export default {
  name: "company-info-basic",
  data() {
    const that = this;
    const cityValid = (rule, value, callback) => {
      if (that.formInline2.country === '中国') { 
        if(value) {
          callback();
        } else {
          callback(new Error("This option is required"));
        }
      } else {
        callback();
      }
    };

    return {
      openBool: true,
      commonType: 2,
      Introduction: [],
      provinceArr: [],
      citiesArr: [],

      countryList: [],
      // countryList: [
      //   {
      //     value: "中国",
      //     label: "中国"
      //   }
      // ],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false, // 控制文件上传方式的显示和隐藏
      formInline2: {
        // form双向绑定
        name: "",
        shortName: "",
        address: "",
        introduction: "",
        country: "中国",
        province: "",
        city: "",
        Website: "",
        CreditCode: "",
        BusinessType: "",
        Nature: "",
        type: "", // 企业类型
        staff: "", // 人员规模
        sales: "", // 年销售额
      },
      ruleInline2: {
        // 效验规则
        name: [
          { required: true, message: "Company name cannot be empty", trigger: "blur" },
          // {
          //   type: "string",
          //   min: 4,
          //   message: "Not less than 4",
          //   trigger: "blur"
          // },
          {
            type: "string",
            max: 100,
            message: "No more than 100",
            trigger: "blur"
          }
        ],
        shortName: [
          { required: true, message: "Company name abbreviation cannot be empty", trigger: "blur" },
          // {
          //   type: "string",
          //   min: 2,
          //   message: "Not less than 2",
          //   trigger: "blur"
          // },
          {
            type: "string",
            max: 15,
            message: "No more than 15",
            trigger: "blur"
          }
        ],
        introduction: [
          { required: true, message: "公司简介不能为空", trigger: "blur" },
          {
            type: "string",
            max: 2000,
            message: "公司简介不能超过2000字",
            trigger: "blur"
          }
        ],
        address: [
          { required: true, message: "Company address cannot be empty", trigger: "blur" }
        ],
        country: [
          { required: true, message: "国家/地区不能为空", trigger: "blur" }
        ], 
        // province: [
        //   {
        //     required: true,
        //     message: "请选择所在的省份",
        //     trigger: "change"
        //   }
        // ],
        // city: [
        //   { required: true, message: "请选择所在的城市", trigger: "change" }
        // ], 
        province: [
          {
            required: true,
            validator: cityValid,
            trigger: "change"
          }
        ],
        city: [
          { required: true, validator: cityValid, trigger: "change" }
        ],

        Nature: [
          { required: true, message: "Type of business cannot be empty", trigger: "change" }
        ],
        BusinessType: [
          { required: true, message: "Type of corporate assets cannot be empty", trigger: "change" }
        ],

        // Website: [
        //   { required: true, message: "公司网址不能为空", trigger: "blur" },
        //   ...validator.Website
        // ],
        CreditCode: [
          {
            required: true,
            message: "Social Unified Credit Code cannot be empty",
            trigger: "blur"
          },
          ...validator.CreditCode
        ],
        type: [
          { required: true, message: "Please select type of enterprise", trigger: "change" }
        ],
        staff: [{ required: true, message: "Please select staff size", trigger: "blur" }],
        sales: [{ required: true, message: "Please enter annual sales", trigger: "blur" }],
      },
      visible: false,
      defaultList: [],

      uploadList: [],

      coverImg: "",
      uploadVideoFlag: false,

      defaultList2: [],
      uploadList2: [],
      limitNum1: 1, // 图文显示的限制图片个数
      BusinessList: [], // 企业性质
      NatureList: [], // 企业经营类别

      commitInfo: null, // 公司信息提交记录
      exTypeList: [],
      staffArr: [
        {
          value: "<10",
          label: "<10"
        },
        {
          value: "10~50",
          label: "10~50"
        },
        {
          value: "50~100",
          label: "50~100"
        },
        {
          value: "100~500",
          label: "100~500"
        },
        {
          value: "500~1000",
          label: "500~1000"
        },
        {
          value: "1000~5000",
          label: "1000~5000"
        },
        {
          value: ">5000",
          label: ">5000"
        }
      ],
    };
  },
  components: {
    imgUpload,
    customComponentCommon,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
    Logo() {
      let logo = defaultLogo;
      if (this.commitInfo && this.commitInfo.logo) {
        logo = this.commitInfo.logo;
      }
      return logo;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCountryList: "exhibitionModule/getCountryList",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      editCompanyDownEdit: "companyModule/editCompanyDownEdit",
      getCompanyDownList: "companyModule/getCompanyDownList",

      getNature: "companyInfoModule/getNature", // 获取企业性质
      getBusinessType: "companyInfoModule/getBusinessType", // 获取企业经营类别
      getCatalogueType: "exhibitionModule/getCatalogueType",
      getCityByParentId: "exhibitionModule/getCityByParentId",
    }),
    async init() {
      this.formInline2.name = this.company.name;
      this.commitInfo = await this.getCompanyDownList(this.joinInfo.joinId);
      if (this.commitInfo) {
        this.formInline2.shortName = this.commitInfo.shortName;
        this.formInline2.address = this.commitInfo.address;
        this.formInline2.introduction = this.commitInfo.introduction;
        this.formInline2.Website = this.commitInfo.website; 
        this.formInline2.CreditCode = this.commitInfo.creditCode;
        this.formInline2.Nature = this.commitInfo.nature;
        this.formInline2.BusinessType = this.commitInfo.businessType; 
        this.defaultList = [
          {
            name: this.commitInfo.name,
            url: this.Logo,
            status: "finished",
            percentage: 100
          }
        ];
        if (this.commitInfo.businessLicenses) {
          this.defaultList2 = [
            {
              name: this.commitInfo.name,
              url: this.commitInfo.businessLicenses,
              status: "finished",
              percentage: 100
            }
          ];
        }
        if (this.commitInfo.country) {
          this.formInline2.country = this.commitInfo.country || "中国";
        }
        if (this.commitInfo.province) {
          this.changeProvince(this.commitInfo.province);
          this.formInline2.province = this.commitInfo.province || "";
        }
        if (this.commitInfo.city) {
          this.changeCity(this.commitInfo.city);
          this.formInline2.city = this.commitInfo.city || "";
        }
        this.uploadList = this.defaultList;
        this.uploadList2 = this.defaultList2;
        if (
          this.commitInfo.introduction &&
          this.commitInfo.introduction.indexOf("[") !== -1
        ) {
          this.Introduction = await this.transformCustomData(
            JSON.parse(this.commitInfo.introduction)
          );
        }
        if (this.commitInfo.industry) {
          this.formInline2.type = this.commitInfo.industry;
        }
        this.formInline2.staff = this.commitInfo.scale;
        this.formInline2.sales = this.commitInfo.annualSales;

        this.BusinessList = await this.getNature();
        this.NatureList = await this.getBusinessType(); 
        let countryList = await this.getCountryList();
        if (countryList && countryList.length > 0) {
          countryList.sort((a, b) => a.nameEn.charCodeAt(0) - b.nameEn.charCodeAt(0));
          this.countryList = countryList;
        }

        let provinceList = await this.getCityByParentId("2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD");
        if (provinceList && provinceList.length > 0) {
          provinceList.sort((a, b) => a.pinyin.charCodeAt(0) - b.pinyin.charCodeAt(0));
          this.provinceArr = provinceList;
          let provinceId = "";
          this.provinceArr.map(c => {
            if (c.shortname === this.formInline2.province) {
              provinceId = c.id;
            }
          })
          if (provinceId) {
            let cityList = await this.getCityByParentId(provinceId);
            if (cityList && cityList.length > 0) {
              this.citiesArr = cityList;
            }
          }
        }
        let res = await this.getCatalogueType();
        if (res) {
          this.exTypeList = res;
        }
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      // const fileList = this.$refs.upload2.fileList;
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
      // this.$refs.upload2.fileList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "Incorrect file format",
        desc: "Upload image in jpg/png format"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "File size exceeds configured limit",
        desc: "Upload image size less than 2M"
      });
    },
    handleMaxSize2(file) {
      this.$Notice.warning({
        title: "File size exceeds configured limit",
        desc: "请上传小于4M的图片"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload ${limitNum} image only`
        });
      }
      return check;
    },
    handleBeforeUpload2() {
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload ${limitNum} image only`
        });
      }
      return check;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadList = [];
      this.defaultList = [];
      this.$refs.upload.fileList = [];
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadList2 = [];
      this.defaultList2 = [];
      this.$refs.upload2.fileList = [];
      this.uploadChooseShowed2 = true;
      this.$refs.upload2.fileList = [];
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadLocal2() {
      this.$refs.upload2.handleClick();
    },
    uploadCancel() {
      this.defaultList = [
        {
          name: this.commitInfo.name,
          url: this.commitInfo.logo,
          status: "finished",
          percentage: 100
        }
      ];
      this.uploadList = this.defaultList;
    },
    uploadCancel2() {
      if (this.commitInfo.businessLicenses) {
        this.defaultList2 = [
          {
            name: this.commitInfo.name,
            url: this.commitInfo.businessLicenses,
            status: "finished",
            percentage: 100
          }
        ];
      } else {
        this.defaultList2 = [];
      }
      this.uploadList2 = this.defaultList2;
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            percentage: 100,
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    // 接收素材库上传的文件
    uploadMaterial2(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList2.push({
            percentage: 100,
            status: "finished",
            url: item
          });
          this.uploadChooseShowed2 = false;
        }
      }
    },

    changeProvince(val) {
    },
    async changeProvinceValue(item) {
      let cityList = await this.getCityByParentId(item.id);
      if (cityList && cityList.length > 0) {
        this.citiesArr = cityList;
      } else {
        this.formInline.city = "";
        this.citiesArr = [];
      }
    },
    changeCity(val) {
    },

    async handleSubmit(name) {
      let form = this.formInline2;
      let valid = await this.validForm(name);
      if (!valid) return;
      let logo = "";
      let BusinessLicenses = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      }
      if (logo === "/static/img/empty.2bfdaae2.png") {
        logo = "";
      }
      if (this.uploadList2 && this.uploadList2.length) {
        BusinessLicenses = this.uploadList2[0].url;
      } else {
        this.$Message.error("请上传公司营业执照");
        return;
      }

      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error(`Please complete the details`);
        return;
      }

      let req = {
        Id: this.commitInfo.id,
        // ExhibitonId: this.exhibition.id,
        // JoinId: this.joinInfo.joinId,
        // CommandId:"2", 
        SetValues: {
          Name: form.name,
          ShortName: form.shortName,
          Address: form.address,
          Logo: logo,
          Country: form.country,
          City: form.city,
          Province: form.province,
          Website: form.Website,
          CreditCode: form.CreditCode,
          BusinessType: form.BusinessType,
          BusinessLicenses: BusinessLicenses,
          Nature: form.Nature,
          Introduction: Introduction,
          Industry: form.type,
          Scale: form.staff,
          AnnualSales: form.sales,
        }
      };
      const bool = await this.editCompanyDownEdit(req);
      if (!bool) {
        this.$Message.error("提交未通过!");
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$Message.success("提交成功!");
      this.$emit("finish");
    },

    changModal($event) {
      this.Introduction = $event; 
    },
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  }
};
</script>

<style scoped lang="scss">
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
  padding-left: 10px;
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
/deep/ .com-city {
  .ivu-form-item-error-tip {
    width: 130%;
  }
}
</style>
